import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { InterestAllocationStore } from '../stores/interestAllocationStore';

export const useInterestAllocationStore = () =>
  useContext<{
    interestAllocationStore: InterestAllocationStore;
  }>(StoreContext);
